import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
import { CTAButton } from './CTAButton';
export function ProductIntro() {
  return <SectionWrapper alternate data-id="element-420">
      <motion.h2 className="font-heading text-2xl md:text-3xl font-bold text-cream mb-10" variants={childVariants} data-id="element-421">
        Introducing: The 3AM Reset{' '}
        <span className="text-cream-muted text-xl md:text-2xl block mt-2" data-id="element-422">
          (For Women 45+)
        </span>
      </motion.h2>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-6" variants={childVariants} data-id="element-423">
        A short, practical ebook built for one job:
      </motion.p>

      <motion.p className="font-heading text-xl md:text-2xl text-cream font-medium leading-relaxed-plus mb-10 pl-4 border-l-2 border-teal/40" variants={childVariants} data-id="element-424">
        Give you a repeatable protocol you can run{' '}
        <em className="text-amber" data-id="element-425">half-asleep</em> — so you stop turning one
        wake-up into an all-night spiral.
      </motion.p>

      <motion.div className="space-y-3 mb-10" variants={childVariants} data-id="element-426">
        <p className="font-body text-lg text-cream-muted leading-relaxed-plus" data-id="element-427">
          No complicated routines.
        </p>
        <p className="font-body text-lg text-cream-muted leading-relaxed-plus" data-id="element-428">
          No medical promises.
        </p>
        <p className="font-body text-lg text-cream-muted leading-relaxed-plus" data-id="element-429">
          No "perfect sleep" obsession.
        </p>
        <p className="font-body text-lg text-cream font-medium leading-relaxed-plus mt-4" data-id="element-430">
          Just a system.
        </p>
      </motion.div>

      <motion.div className="flex justify-center pt-4" variants={childVariants} data-id="element-431">
        <CTAButton href="#pricing" data-id="element-432">Download The 3AM Reset</CTAButton>
      </motion.div>
    </SectionWrapper>;
}